import { ReactNode, useMemo } from 'react'

import { ChainHealthBanner } from '~/components/Layout/ChainHealthBanner'
import { ViewAsBanner } from '~/components/Layout/ViewAsBanner'
import { useIsOrgOverridden } from '~/hooks/org'
import { useAuthUser } from '~/hooks/useAuthUser'
import { useStalledChainIds } from '~/hooks/useChainHealth'

/**
 * Determine if the global page banner should be shown.
 */
export const useBanner = () => {
  const stalledChains = useStalledChainIds()
  const isOrgOverridden = useIsOrgOverridden()
  const { user: authUser } = useAuthUser()

  const showBanner = authUser && (stalledChains.size > 0 || isOrgOverridden)

  const banner: ReactNode = useMemo(() => {
    if (!showBanner) return
    if (isOrgOverridden) return <ViewAsBanner />
    if (stalledChains.size > 0) return <ChainHealthBanner />
  }, [showBanner, isOrgOverridden, stalledChains])

  return {
    stalledChains,
    isOrgOverridden,
    showBanner,
    banner,
  }
}
